// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__mukta_1fce0e', '__mukta_Fallback_1fce0e', s, a, n, s, -, s, e, r, i, f","fontStyle":"normal"},"className":"__className_1fce0e"};